import React from "react";
import { useTranslation } from "react-i18next";
import { Route, useHistory, useRouteMatch } from "react-router";
import { GoBackButton, withBreadCrumbs } from "lego-gui-lib";
import { TabContent, TabData } from "../../san/tabs/TabContent";
import { TabHeader } from "../../san/tabs/TabHeader";
import { TreeView } from "./TreeView";
import { Show } from "./views";
import { TitleRow } from "lego-gui-lib/lib/components/Views/TitleRow";
import { observer } from "mobx-react-lite";

export const TreeTabsView = observer(({ location }: any) => {
  const i18n = useTranslation();
  const match = useRouteMatch();
  const title = i18n.t("hns:tree:domain");
  const t = i18n.t.bind(i18n);
  const baseUrl = match.url;
  const history = useHistory();

  const ShowView = () => {
    const localMatch = useRouteMatch();
    // @ts-ignore
    const treeId = match.params.id;
    return <Show match={localMatch} id={{ id: treeId }} />;
  };

  const GraphView = () => {
    return <TreeView />;
  };

  const tabs: TabData[] = [
    {
      label: t("common:general"),
      path: "/general",
      Element: <ShowView />
    },
    {
      label: t("hns:tree:graph"),
      path: "/graph",
      Element: <GraphView />
    }
  ];

  return withBreadCrumbs(
    { to: baseUrl + "/edit", children: title },
    <>
      <Route
        path={baseUrl}
        render={() => {
          return (
            <>
              <TitleRow
                title={title}
                prefix={<GoBackButton goBack={() => history.goBack()} />}
              />
              <TabHeader
                baseUrl={baseUrl}
                tabs={tabs}
                value={location.pathname}
              />
            </>
          );
        }}
      />

      <TabContent baseUrl={baseUrl} tabs={tabs} />
    </>
  );
});
